export default "__VITE_ASSET__6f2f0c37__"